import { useEffect } from 'react';
import SEOHead from '../components/SEO/SEOHead';
import SchemaOrg from '../components/SEO/SchemaOrg';
import SkipLinks from '../components/Accessibility/SkipLinks';
import AccessibilityToolbar from '../components/Accessibility/AccessibilityToolbar';
import Navigation from '../components/Navigation';
import Hero from '../components/Hero';
import SituationsSection from '../components/SituationsSection';
import About from '../components/About';
import Services from '../components/Services';
import Values from '../components/Values';
import FreeResources from '../components/FreeResources';
import Testimonials from '../components/Testimonials';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import ScrollToTop from '../components/ScrollToTop';
import { ThemeProvider } from '../hooks/useTheme';

export default function HomePage() {
  useEffect(() => {
    // Scroll to hash on load
    const hash = window.location.hash;
    if (hash) {
      const element = document.getElementById(hash.slice(1));
      if (element) {
        setTimeout(() => {
          const offset = 80;
          const y = element.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }, 100);
      }
    }
  }, []);

  return (
    <ThemeProvider>
      <SEOHead />
      <SchemaOrg />
      <SkipLinks />
      <AccessibilityToolbar />
      <Navigation />
      <div id="app-content" className="min-h-screen bg-warm-gray-50 dark:bg-warm-gray-900 overflow-x-hidden transition-colors duration-300">
        <main id="main-content">
          <Hero />
          <SituationsSection />
          <About />
          <Services />
          <Values />
          <FreeResources />
          <Testimonials />
          <Contact />
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    </ThemeProvider>
  );
}
